// src/components/Alarms/ReasonModal.js
import React, { useState, useEffect } from 'react';

// ReasonModal - Handles both:
 
const ReasonModal = ({ isOpen, onClose, onSubmit, alarm, loading, mode = 'acknowledge' }) => {
  const [formData, setFormData] = useState({ resolution_message: '' });
  const [errors, setErrors] = useState({});

  // Reset form when modal opens
  useEffect(() => {
    if (isOpen && alarm) {
      setFormData({ resolution_message: alarm.resolution_message || '' });
      setErrors({});
    }
  }, [isOpen, alarm]);

  const handleInputChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({ ...prev, resolution_message: value }));
    if (errors.resolution_message) {
      setErrors((prev) => ({ ...prev, resolution_message: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (mode === 'acknowledge' && !formData.resolution_message.trim()) {
      newErrors.resolution_message = 'Resolution message is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (mode === 'acknowledge' && !validateForm()) return;
    onSubmit(alarm.id, formData);
  };

  if (!isOpen || !alarm) return null;

  const isViewMode = mode === 'view';

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {isViewMode ? 'Resolution Reason' : 'Acknowledge Alarm'}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={loading}
            ></button>
          </div> 

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label fw-semibold">
                  {isViewMode ? 'Resolution Message' : 'Resolution Message '}
                  {!isViewMode && <span className="text-danger">*</span>}
                </label>

                {isViewMode ? (
                  <div
                    className="form-control"
                    style={{ minHeight: '100px', backgroundColor: '#f8f9fa' }}
                  >
                    {formData.resolution_message || (
                      <em className="text-muted">No resolution message provided.</em>
                    )}
                  </div>
                ) : (
                  <textarea
                    name="resolution_message"
                    value={formData.resolution_message}
                    onChange={handleInputChange}
                    className={`form-control ${
                      errors.resolution_message ? 'is-invalid' : ''
                    }`}
                    rows="4"
                    placeholder="Enter resolution message..."
                    disabled={loading}
                  />
                )}

                {errors.resolution_message && !isViewMode && (
                  <div className="invalid-feedback">{errors.resolution_message}</div>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={onClose}
                disabled={loading}
              >
                Close
              </button>

              {!isViewMode && (
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading || !formData.resolution_message.trim()}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Acknowledging...
                    </>
                  ) : (
                    'Acknowledge'
                  )}
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReasonModal;